import React from "react";

export const RectCheckboxIcon = ({ checked = false, color = "#f6615f" }) => (
  <span
    className={`risk-checkbox-rect${checked ? " is-checked" : ""}`}
    style={{ "--risk-checkbox-color": color }}
  />
);

export const rectCheckboxProps = (color) => ({
  icon: <RectCheckboxIcon color={color} />,
  checkedIcon: <RectCheckboxIcon checked color={color} />,
});
